import moment from 'moment';
import * as fabric from 'office-ui-fabric-react';
import React, { FC, useEffect, useState } from 'react';
import * as api from '../../../api/generated';
import { blueButton, centeredModal, fullScreenStyles, transparentButton } from '../Helpers';
import { ITicket } from '../model';

interface RelateTicketModalProps {
    showMe: boolean;
    setShowRelate(value: boolean): void;
    ticket: ITicket | null;
}

export type PatientVisits = {
    id: string | null;
    firstName: string | null;
    lastName: string | null;
    visits: {
        id: string | null;
        visitDateTime: moment.Moment;
        practitioner: {
            id: string | null;
            firstName: string | null;
            lastName: string | null;
            qualification: string | null;
            workplaceNumber: string | null;
            workplaceFloor: string | null;
        } | null;
        isFMR: boolean;
    }[];
} | null;

export type RegistrationInfo = {
    ticketNumber: string | null;
    patient: PatientVisits;
};

export const RelateTicketModal: FC<RelateTicketModalProps> = (props: RelateTicketModalProps) => {
    const [showError, setShowError] = useState<string>();
    const [registrationData, setRegistrationData] = useState<PatientVisits>();
    const [selectedVisit, setSelectedVisit] = useState<string>();
    const [ticketAssigned, setTicketAssigned] = useState<string | null>('');
    const [registrationInfo, setRegistrationInfo] = useState<RegistrationInfo | null>(null);

    useEffect(() => {
        getVisitInfo(props.ticket!.id);
    }, []);

    const getVisitInfo = async (id: number) => {
        try {
            setRegistrationInfo(await api.queueManagement.getVisitInfo(id));
        } catch (e) {
            setShowError(e.error ? e.error[0] : 'Aplikacija nepasiekiama');
        }
    };

    const getRegistrations = async (id: string) => {
        if (id.length == 11) {
            try {
                setRegistrationData(await api.queueManagement.getPatientVisitsByIdentificationNumber(id));
            } catch (e) {
                // setRegistrationData({"id":"7086","firstName":"PAULIUS","lastName":"DAUNYS",
                //     "visits":[{"id":"7086","visitDateTime":moment("2020-07-01T11:00:00"),
                //     "practitioner":{"id":"0","firstName":"AURIKA BIRUTĖ",
                //     "lastName":" JUREVIČIENĖ","qualification":"AURIKA qualification",
                //     "workplaceNumber":"workplaceNumber","workplaceFloor":"workplaceFloor"},"isFMR":false}]});
                setShowError(e.error ? e.error[0] : 'Aplikacija nepasiekiama');
            }
        }
    };

    const setRegistration = async () => {
        try {
            var visit = registrationData?.visits.filter(x => x.id == selectedVisit)[0];

            if (registrationData && visit) {
                var model = {
                    ticketId: props.ticket!.id,
                    regId: visit.id,
                    isFMR: visit.isFMR!,
                    visitDateTime: visit.visitDateTime,
                    patientId: registrationData?.id,
                    patientFirstName: registrationData?.firstName,
                    patientLastName: registrationData?.lastName,
                    externalLocationKey: visit.practitioner?.workplaceNumber!,
                    currentLocationId: parseInt(localStorage.getItem('locationId')!)
                };

                await api.queueManagement.updateTicketRegistration(model);
                props.setShowRelate(false);
            }
        } catch (e) {
            setShowError(e.error ? e.error[0] : 'Aplikacija nepasiekiama');
        }
    };

    const cancelRegistration = async (ticketId: number) => {
        try {
            await api.queueManagement.cancelExternalVisit(ticketId);
            setRegistrationInfo(null);
        } catch (e) {
            setShowError(e.error ? e.error[0] : 'Aplikacija nepasiekiama');
        }
    };

    const checkExistingTicket = async (regId: string) => {
        try {
            setTicketAssigned(await api.queueManagement.checkTicketByVisit(regId));
        } catch (e) {
            setShowError(e.error ? e.error[0] : 'Aplikacija nepasiekiama');
        }
    };

    return (
        <>
            {props.showMe && (
                <fabric.Stack styles={fullScreenStyles}>
                    <fabric.Stack styles={centeredModal} style={{ minWidth: '500px', maxWidth: '700px' }}>
                        {props.ticket && (
                            <fabric.Stack.Item align="center" styles={{ root: { width: '100%' } }}>
                                <fabric.Stack style={{ background: '#4A9491', color: 'white', flex: 1 }} horizontalAlign="center">
                                    <fabric.Text variant="large">Identifikuoti pacientą</fabric.Text>
                                </fabric.Stack>

                                <fabric.Stack style={{ margin: '3vw' }}>
                                    {registrationInfo && registrationInfo.patient && registrationInfo?.patient.visits.length > 0 && (
                                        <fabric.Stack>
                                            <fabric.Stack style={{ alignItems: 'center', marginBottom: '2vw' }} horizontal>
                                                <fabric.Stack>
                                                    <fabric.Stack style={{ alignItems: 'center' }} horizontal>
                                                        <fabric.Text style={{ marginRight: '20px', fontWeight: 'bold' }}>
                                                            Priskirta bilietui Nr. {props.ticket!.number}
                                                        </fabric.Text>
                                                        <fabric.DefaultButton
                                                            styles={blueButton}
                                                            onClick={() => {
                                                                cancelRegistration(props.ticket?.id!);
                                                            }}
                                                        >
                                                            Atšaukti
                                                        </fabric.DefaultButton>
                                                    </fabric.Stack>
                                                </fabric.Stack>
                                            </fabric.Stack>
                                        </fabric.Stack>
                                    )}

                                    <fabric.Stack>
                                        <fabric.Text variant={'large'}>Paieška</fabric.Text>
                                    </fabric.Stack>
                                    <fabric.Stack styles={{ root: { display: 'flex', flexDirection: 'row', alignItems: 'center' } }} horizontal>
                                        <fabric.Text style={{ marginRight: '10px' }}>Įveskite arba nuskanuokite asmens kodą</fabric.Text>
                                        <fabric.TextField
                                            placeholder={'asmens kodas'}
                                            maxLength={11}
                                            onChange={(e: any) => getRegistrations(e.target.value)}
                                        ></fabric.TextField>
                                    </fabric.Stack>

                                    <fabric.Stack horizontal>
                                        {props.ticket.patientFirstName && (
                                            <fabric.Text style={{ marginRight: '10px' }}>
                                                {props.ticket!.patientFirstName} {props.ticket!.patientLastName}
                                            </fabric.Text>
                                        )}
                                        {ticketAssigned && <fabric.Text>Priskirtas bilietas - {ticketAssigned}</fabric.Text>}
                                    </fabric.Stack>

                                    <table style={{ width: '100%', marginTop: '20px' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ minWidth: '140px' }}>Laikas</th>
                                                <th>Kabinetas</th>
                                                <th>Aukštas</th>
                                                <th>Gydytojas / Procedūros</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {registrationData && registrationData.visits.length ? (
                                                <>
                                                    {registrationData.visits.map(x => (
                                                        <tr>
                                                            <td>
                                                                {x.id && (
                                                                    <label style={{ cursor: 'pointer' }} htmlFor={`visitRadio${x.id}`}>
                                                                        <input
                                                                            id={`visitRadio${x.id}`}
                                                                            type={'radio'}
                                                                            name={'visitGroup'}
                                                                            value={x.id.toString()}
                                                                            onChange={({}: any) => {
                                                                                x.id && setSelectedVisit(x.id);
                                                                                x.id && checkExistingTicket(x.id);
                                                                            }}
                                                                        />
                                                                        {x.visitDateTime.local().format('DD/MM/YYYY HH:mm')}
                                                                    </label>
                                                                )}
                                                            </td>
                                                            <td>{x.practitioner && x.practitioner?.workplaceNumber}</td>
                                                            <td>{x.practitioner && x.practitioner?.workplaceFloor}</td>
                                                            <td>
                                                                {x.practitioner &&
                                                                    `${x.practitioner?.qualification} ${x.practitioner?.firstName} ${x.practitioner?.lastName}`}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </>
                                            ) : (
                                                <tr>
                                                    <td colSpan={5}>
                                                        <fabric.Text>Registracijų nerasta</fabric.Text>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>

                                    <fabric.Stack.Item styles={{ root: { marginTop: '3vw !important' } }}>
                                        <fabric.DefaultButton
                                            styles={transparentButton}
                                            disabled={!selectedVisit || ticketAssigned!.length > 0}
                                            onClick={() => {
                                                setRegistration();
                                            }}
                                        >
                                            Patvirtinti
                                        </fabric.DefaultButton>

                                        <fabric.DefaultButton
                                            styles={transparentButton}
                                            onClick={() => {
                                                props.setShowRelate(false);
                                            }}
                                        >
                                            Uždaryti
                                        </fabric.DefaultButton>
                                    </fabric.Stack.Item>
                                    {showError && (
                                        <fabric.Stack.Item styles={{ root: { marginTop: '2vw !important' } }}>
                                            <fabric.Text styles={{ root: { color: 'red' } }}>{showError}</fabric.Text>
                                        </fabric.Stack.Item>
                                    )}
                                </fabric.Stack>
                            </fabric.Stack.Item>
                        )}
                    </fabric.Stack>
                </fabric.Stack>
            )}
        </>
    );
};
